import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TaxasService {
  BASEURL: string;
  httpHeaders: HttpHeaders;

  constructor(private http: HttpClient) {
    this.BASEURL = environment.apiUrl;

    this.httpHeaders = new HttpHeaders({
      Authorization: localStorage.getItem('tokenMappe'),
    });
  }

  listaTaxas(): Observable<any> {
    return this.http.get(`${this.BASEURL}/fees`, {
      headers: this.httpHeaders,
    });
  }

  listaItemTaxa(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/fees/${id}`, {
      headers: this.httpHeaders,
    });
  }

  salvaTaxa(body: any): Observable<any> {
    return this.http.post(`${this.BASEURL}/fees`, body, {
      headers: this.httpHeaders,
    });
  }

  editarItemTaxa(id: string, body: any): Observable<any> {
    return this.http.put(`${this.BASEURL}/fees/${id}`, body, {
      headers: this.httpHeaders,
    });
  }

  excluirItemTaxa(id: string): Observable<any> {
    return this.http.delete(`${this.BASEURL}/fees/${id}`, {
      headers: this.httpHeaders,
    });
  }
}
